import actionCreatorFactory from 'typescript-fsa';
import { ERRORS } from '../actionTypes';

const actionCreator = actionCreatorFactory();

const newError = actionCreator<Error>(ERRORS);

export default newError;
